<template>
	<div>
		<v-card-title v-if="title" class="d-flex align-center">
			{{ title }}
			<v-icon color="info" @click="load">$reload</v-icon>
		</v-card-title>
		<v-card-text class="form-inline">
			<span v-if="selectedBean">{{ selectedBean.name }}</span>
			<bean-selector @selected="onBeanSelected" class="mr-1">选择豆</bean-selector>
			<date-picker v-model="query.date" label="选择日期" class="search-field-date mr-1">
				<template v-slot:activator="slotProps">
					<v-btn v-bind="slotProps.props">
						<template v-if="slotProps.displayDate">
							{{ slotProps.displayDate }}
						</template>
						<template v-else>选择日期</template>
					</v-btn>
				</template>
			</date-picker>
			<v-select
				outlined
				density="compact"
				label="豆类型"
				v-model="query.bean_type"
				:items="refs['BeanType']"
				hide-details
				clearable
				class="mr-1"
			></v-select>
			<v-select
				outlined
				density="compact"
				label="批次类型"
				v-model="query.type"
				:items="refs['BatchType']"
				hide-details
				clearable
				class="mr-1"
			></v-select>
			<v-btn color="primary" @click="search">
				<v-icon>$search</v-icon>
				查询
			</v-btn>
			<v-icon v-if="queryPairs.length > 0" @click="reset">$close</v-icon>
		</v-card-text>
		<v-data-table-server
			:headers="headers"
			:items="objects"
			:options.sync="options"
			:loading="loading"
			:show-select="showSelect"
			:single-select="singleSelect"
			@update:options="load"
			:items-length="parseInt(total)"
			v-model="selected"
			multi-sort
		>
			<template v-slot:top>
				<slot name="batchActions" v-bind:selected="selected"></slot>
			</template>

			<template v-slot:item.status="{ item }">
				<enum-chip kind="status" :value="item.status" />
			</template>
			<template v-slot:item.type="{ item }">
				<enum-chip kind="batchType" :value="item.type" />
			</template>
			<template v-slot:item.bean_type="{ item }">
				<enum-chip kind="beanType" :value="item.bean_type" />
			</template>
			<template v-slot:item.name="{ item }">{{ item.code }} {{ item.name }}</template>
			<template v-slot:item.action="{ item }">
				<slot name="actions" v-bind:item="item"></slot>
			</template>

			<template v-slot:footer>
				<slot name="batchActions" v-bind:selected="selected"></slot>
			</template>
		</v-data-table-server>
	</div>
</template>

<script>
import DatePicker from '../common/DatePicker.vue'
import BeanSelector from './Selector.vue'
import EnumChip from '../common/EnumChip.vue'
import { clone, valuesIn, toPairsIn, filter, intersection } from 'lodash-es'

export default {
	components: { BeanSelector, DatePicker, EnumChip },
	props: {
		beanId: { type: [Number, String], default: null },
		beanType: { type: String, default: null },
		batchType: { type: String, default: null },
		title: { type: String, default: null },
		showSelect: { type: Boolean, default: false },
		singleSelect: { type: Boolean, default: true },
		filter: { type: Object, default: null },
		headers: {
			type: Array,
			default: () => [
				{ title: '#', value: 'id' },
				{ title: '日期', align: 'left', sortable: true, value: 'date' },
				{ title: '豆类型', sortable: true, value: 'bean_type' },
				{ title: '类型', sortable: true, value: 'type' },
				{ title: '总数量', sortable: true, value: 'totalqty' },
				{ title: '当前数量', sortable: true, value: 'currentqty' },
				{ title: '状态', value: 'status' },
				{ title: '', align: 'left', sortable: false, value: 'action' }
			]
		}
	},
	data() {
		return {
			query: {},
			currentQuery: {}, //当前结果的查询条件
			objects: [],
			total: 0,
			loading: false,
			options: {},
			refs: {},
			selected: [],
			errors: {},
			selectedBean: null
		}
	},
	mounted() {
		if (this.filter) {
			this.query = clone(this.filter)
		}
		this.$api.bean.meta(`BatchType,BeanType`, (r) => {
			this.refs = r
		})
		if (this.beanId) {
			this.$api.bean.getById(this.beanId, (r) => {
				this.query['bean_id'] = this.beanId
				this.selectedBean = r
			})
		}
		if (this.beanType) {
			this.query['bean_type'] = this.beanType
		}
		if (this.batchType) {
			this.query['type'] = this.batchType
		}
	},
	computed: {
		queryValues() {
			return filter(valuesIn(this.query), (e) => !!e)
		},
		currentQueryValues() {
			return filter(valuesIn(this.currentQuery), (e) => !!e)
		},
		queryPairs() {
			return filter(toPairsIn(this.query), (e) => !!e[1])
		}
	},
	watch: {
		options: {
			handler() {
				this.load()
			},
			deep: true
		}
	},
	methods: {
		search() {
			this.load()
		},
		reset() {
			this.query = {}
			if (this.filter) {
				this.query = clone(this.filter)
			}
		},
		onBeanSelected(ids, objs) {
			this.selectedBean = objs[0]
			this.query['bean_id'] = ids[0]
		},
		load(options = null) {
			if (!this.options) this.options = {}
			if (options) {
				this.options = options
			}

			let { sortBy, page, itemsPerPage } = this.options
			this.loading = true
			let qwp = clone(this.query)
			qwp.pageno = page
			qwp.pagesize = itemsPerPage
			qwp.sortBy = 'id'
			qwp.sortDesc = 'desc'
			if (sortBy && sortBy.length > 0) {
				qwp.sort = sortBy.map((e) => `${e.key} ${e.order}`).join(',')
				qwp.sortBy = sortBy[0]['key']
				qwp.sortDesc = sortBy[0]['order']
			}

			this.currentQuery = clone(this.query)
			if (this.beanId) {
				qwp['bean_id'] = this.beanId
			}
			if (this.beanType) {
				qwp['bean_type'] = this.beanType
			}
			if (this.batchType) {
				qwp['type'] = this.batchType
			}
			this.$api.bean.searchBatch(
				qwp,
				(response) => {
					this.objects = response.objects
					this.total = response.total
					this.loading = false
				},
				(error) => {
					this.errors = error.message
					this.loading = false
				}
			)
		}
	}
}
</script>

<style scoped>
.silent td {
	color: rgba(3, 3, 3, 0.5) !important;
}
</style>
